import React from 'react';
import Swipeable from 'react-swipeable-views';

const styles = {
  root: {
    padding: '0 730px 0 0',
  },
  slideContainer: {
    // padding: '0 10px',
  },
  slide: {
    padding: 15,
    minHeight: 100,
    color: '#fff',
  },
  slide1: {
    background: '#FEA900',
  },
  slide2: {
    background: '#B3DC4A',
  },
  slide3: {
    background: '#6AC0FF',
  },
};

const SwipeableViews = ({ children, style }) => {
  return (
    <Swipeable
      enableMouseEvents
      style={{
        ...styles.root,
        ...style
      }}
      slideStyle={styles.slideContainer}
    >
      {children}
    </Swipeable>
  )
};

export default SwipeableViews;